import CellSelectionModel from './slick.cellselectionmodel';
export default CellSelectionModel;
